(function ($) {
	'use strict';

	if (
		typeof elementor === 'undefined' ||
		!elementor.modules ||
		!elementor.modules.controls ||
		!elementor.modules.controls.BaseData
	) {
		return;
	}

	var styleInjected = false;

	function escapeHtml(value) {
		return String(value || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}

	function defaultCell() {
		return { icon: { value: 'eicon-check', library: 'icon' }, label: 'Value' };
	}

	function normalizeCell(cell) {
		var normalized = cell && typeof cell === 'object' ? cell : {};
		var icon = normalized.icon && typeof normalized.icon === 'object' ? normalized.icon : null;
		var label = typeof normalized.label === 'string' ? normalized.label : '';

		if (!icon && normalized.type) {
			var legacyIcons = {
				text: null,
				check: { value: 'eicon-check', library: 'icon' },
				cross: { value: 'eicon-close', library: 'icon' },
				check_label: { value: 'eicon-check', library: 'icon' },
				cross_label: { value: 'eicon-close', library: 'icon' },
			};
			icon = legacyIcons[normalized.type] || null;
		}

		if (!label && typeof normalized.text === 'string') {
			label = normalized.text;
		}

		return {
			icon: icon,
			label: label,
		};
	}

	function normalizeSelectedIcon(icon) {
		if (!icon) {
			return { value: '', library: '' };
		}

		if ('string' === typeof icon) {
			return { value: icon, library: 'icon' };
		}

		if ('svg' === icon.library) {
			return {
				value: {
					url: icon.value && icon.value.url ? icon.value.url : '',
					id: icon.value && icon.value.id ? icon.value.id : '',
				},
				library: 'svg',
			};
		}

		return {
			value: icon.value || '',
			library: icon.library || 'icon',
		};
	}

	function renderIconPreview(icon) {
		if (!icon || !icon.library || !icon.value) {
			return '<i class="eicon-plus" aria-hidden="true"></i>';
		}

		if ('svg' === icon.library && icon.value.url) {
			return '<img src="' + escapeHtml(icon.value.url) + '" alt="" />';
		}

		return '<i class="' + escapeHtml(icon.value) + '" aria-hidden="true"></i>';
	}

	function normalizeRow(row) {
		var normalized = row && typeof row === 'object' ? row : {};
		var cells = Array.isArray(normalized.cells) ? normalized.cells.map(normalizeCell) : [];
		if (!cells.length) {
			cells = [defaultCell()];
		}
		return {
			name: typeof normalized.name === 'string' ? normalized.name : 'Feature Name',
			cells: cells,
		};
	}

	function normalizeCategory(category) {
		var normalized = category && typeof category === 'object' ? category : {};
		var rows = Array.isArray(normalized.rows) ? normalized.rows.map(normalizeRow) : [];
		if (!rows.length) {
			rows = [normalizeRow({})];
		}
		return {
			title: typeof normalized.title === 'string' ? normalized.title : 'Category',
			rows: rows,
		};
	}

	function parseMatrix(value) {
		if (Array.isArray(value)) {
			return value.map(normalizeCategory);
		}

		if (typeof value !== 'string' || !value.trim()) {
			return [];
		}

		try {
			var parsed = JSON.parse(value);
			return Array.isArray(parsed) ? parsed.map(normalizeCategory) : [];
		} catch (e) {
			return [];
		}
	}

	var AdvanceNastedRepeterControl = elementor.modules.controls.BaseData.extend({
		events: {
			'click .thha-anr-add-category': 'onAddCategory',
			'click .thha-anr-remove-category': 'onRemoveCategory',
			'input .thha-anr-category-title': 'onCategoryTitleChange',
			'click .thha-anr-add-row': 'onAddRow',
			'click .thha-anr-remove-row': 'onRemoveRow',
			'input .thha-anr-row-name': 'onRowNameChange',
			'click .thha-anr-add-cell': 'onAddCell',
			'click .thha-anr-remove-cell': 'onRemoveCell',
			'input .thha-anr-cell-label': 'onCellLabelChange',
			'click .thha-anr-icon-picker': 'onOpenIconPicker',
			'click .thha-anr-icon-clear': 'onClearIcon',
		},

		onReady: function () {
			this.injectStyle();
			this.initializeMatrix();
		},

		injectStyle: function () {
			if (styleInjected || document.getElementById('thha-anr-control-style')) {
				styleInjected = true;
				return;
			}

			var css = '' +
				'.thha-anr-control-shell{margin-top:8px}' +
				'.thha-anr-root{margin-top:8px}' +
				'.thha-anr-toolbar{display:flex;justify-content:flex-end;margin-bottom:10px}' +
				'.thha-anr-btn{appearance:none;border:1px solid #3f4147;background:#232428;color:#e8e9ec;border-radius:4px;padding:6px 10px;font-size:12px;line-height:1.2;cursor:pointer;transition:background-color .15s ease,border-color .15s ease,color .15s ease}' +
				'.thha-anr-btn:hover{background:#2a2c31;border-color:#5f6368}' +
				'.thha-anr-btn-danger{border-color:#6d2b2d;background:#251a1b;color:#ffb9be}' +
				'.thha-anr-btn-danger:hover{background:#2e1d1f;border-color:#a24a4d;color:#ffd6d8}' +
				'.thha-anr-category{border:1px solid #3a3d44;border-radius:8px;padding:10px;margin-bottom:12px;background:#1e1f23;box-shadow:0 1px 0 rgba(255,255,255,.03) inset}' +
				'.thha-anr-category-head{display:flex;gap:8px;align-items:center;margin-bottom:10px}' +
				'.thha-anr-input{width:100%;border:1px solid #3f4248;border-radius:4px;padding:7px 10px;font-size:13px;background:#121316;color:#f1f2f5;box-sizing:border-box}' +
				'.thha-anr-input:focus{outline:none;border-color:#8b8e95;box-shadow:0 0 0 1px rgba(255,255,255,.06)}' +
				'.thha-anr-rows{display:grid;gap:10px}' +
				'.thha-anr-row{border:1px solid #34373d;border-radius:8px;background:#18191d;padding:10px}' +
				'.thha-anr-row-head{display:flex;gap:8px;align-items:center;margin-bottom:10px}' +
				'.thha-anr-cells{display:grid;gap:8px;margin-bottom:10px}' +
				'.thha-anr-cell{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px;align-items:start}' +
				'.thha-anr-cell-main{display:flex;flex-direction:column;gap:8px;min-width:0}' +
				'.thha-anr-icon-picker-wrap{display:flex;flex-direction:column;gap:8px;align-items:stretch;min-width:0}' +
				'.thha-anr-icon-picker{display:flex;align-items:center;gap:8px;width:100%;min-width:0;border:1px solid #3f4248;border-radius:4px;background:#121316;color:#f1f2f5;padding:7px 10px;font-size:12px;cursor:pointer;text-align:left}' +
				'.thha-anr-icon-picker:hover{border-color:#8b8e95}' +
				'.thha-anr-icon-preview{width:28px;height:28px;display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;color:#f1f2f5}' +
				'.thha-anr-icon-preview img{display:block;max-width:100%;max-height:100%}' +
				'.thha-anr-icon-picker-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;color:#f1f2f5}' +
				'.thha-anr-icon-clear{align-self:flex-start}' +
				'.thha-anr-cell-label{width:100%}' +
				'.thha-anr-row-actions,.thha-anr-category-actions{display:flex;gap:8px;justify-content:flex-end}' +
				'.thha-anr-empty{padding:10px;color:#a7abb2;font-size:12px;text-align:center;border:1px dashed #44474d;border-radius:6px;background:#191a1e}' +
				'.thha-anr-help{margin-top:6px;color:#9da3ae;font-size:11px;line-height:1.45;font-style:italic}';

			var style = document.createElement('style');
			style.id = 'thha-anr-control-style';
			style.appendChild(document.createTextNode(css));
			document.head.appendChild(style);
			styleInjected = true;
		},

		getDefaultMatrix: function () {
			var defaults = parseMatrix(this.model.get('default'));
			if (defaults.length) {
				return defaults;
			}
			return [normalizeCategory({})];
		},

		getCurrentCell: function (categoryIndex, rowIndex, cellIndex) {
			if (
				!Number.isInteger(categoryIndex) ||
				!Number.isInteger(rowIndex) ||
				!Number.isInteger(cellIndex) ||
				!this.matrix[categoryIndex] ||
				!this.matrix[categoryIndex].rows[rowIndex] ||
				!this.matrix[categoryIndex].rows[rowIndex].cells[cellIndex]
			) {
				return null;
			}

			return this.matrix[categoryIndex].rows[rowIndex].cells[cellIndex];
		},

		getLegacyCategories: function () {
			if (!this.container || !this.container.settings) {
				return [];
			}

			var legacy = this.container.settings.get('comparison_categories');
			return Array.isArray(legacy) ? legacy.map(normalizeCategory) : [];
		},

		initializeMatrix: function () {
			var matrix = parseMatrix(this.getControlValue());

			if (!matrix.length) {
				matrix = this.getLegacyCategories();
			}

			if (!matrix.length) {
				matrix = this.getDefaultMatrix();
			}

			this.matrix = matrix;
			this.refresh();
		},

		refresh: function () {
			this.syncValue();
			this.renderEditor();
		},

		syncValue: function () {
			var value = JSON.stringify(this.matrix);
			this.setValue(value);
			this.$('input[data-setting]').val(value).trigger('input');
		},

		renderEditor: function () {
			var html = '';
			html += '<div class="thha-anr-toolbar"><button type="button" class="thha-anr-btn thha-anr-add-category">+ Add Category</button></div>';
			html += '<div class="thha-anr-categories">';

			if (!this.matrix.length) {
				html += '<div class="thha-anr-empty">No categories yet.</div>';
			}

			for (var c = 0; c < this.matrix.length; c++) {
				html += this.renderCategory(this.matrix[c], c);
			}

			html += '</div>';
			this.$('.thha-anr-root').html(html);
		},

		renderCategory: function (category, categoryIndex) {
			var html = '';
			html += '<div class="thha-anr-category" data-category-index="' + categoryIndex + '">';
			html += '<div class="thha-anr-category-head">';
			html += '<input class="thha-anr-input thha-anr-category-title" type="text" value="' + escapeHtml(category.title) + '" placeholder="Category Title" />';
			html += '<button type="button" class="thha-anr-btn thha-anr-btn-danger thha-anr-remove-category">Remove</button>';
			html += '</div>';
			html += '<div class="thha-anr-rows">';

			for (var r = 0; r < category.rows.length; r++) {
				html += this.renderRow(category.rows[r], categoryIndex, r);
			}

			html += '</div>';
			html += '<div class="thha-anr-category-actions"><button type="button" class="thha-anr-btn thha-anr-add-row">+ Add Row</button></div>';
			html += '</div>';
			return html;
		},

		renderRow: function (row, categoryIndex, rowIndex) {
			var html = '';
			html += '<div class="thha-anr-row" data-category-index="' + categoryIndex + '" data-row-index="' + rowIndex + '">';
			html += '<div class="thha-anr-row-head">';
			html += '<input class="thha-anr-input thha-anr-row-name" type="text" value="' + escapeHtml(row.name) + '" placeholder="Feature Name" />';
			html += '<button type="button" class="thha-anr-btn thha-anr-btn-danger thha-anr-remove-row">Remove</button>';
			html += '</div>';
			html += '<div class="thha-anr-cells">';

			for (var i = 0; i < row.cells.length; i++) {
				html += this.renderCell(row.cells[i], categoryIndex, rowIndex, i);
			}

			html += '</div>';
			html += '<div class="thha-anr-row-actions"><button type="button" class="thha-anr-btn thha-anr-add-cell">+ Add Cell</button></div>';
			html += '</div>';
			return html;
		},

		renderCell: function (cell, categoryIndex, rowIndex, cellIndex) {
			var html = '';
			var iconValue = cell.icon && 'svg' === cell.icon.library ? 'SVG selected' : (cell.icon && cell.icon.value ? cell.icon.value : 'Choose Icon');
			html += '<div class="thha-anr-cell" data-category-index="' + categoryIndex + '" data-row-index="' + rowIndex + '" data-cell-index="' + cellIndex + '">';
			html += '<div class="thha-anr-cell-main">';
			html += '<div class="thha-anr-icon-picker-wrap">';
			html += '<button type="button" class="thha-anr-icon-picker" data-category-index="' + categoryIndex + '" data-row-index="' + rowIndex + '" data-cell-index="' + cellIndex + '">';
			html += '<span class="thha-anr-icon-preview">' + renderIconPreview(cell.icon) + '</span>';
			html += '<span class="thha-anr-icon-picker-label">' + escapeHtml(iconValue) + '</span>';
			html += '</button>';
			html += '<button type="button" class="thha-anr-btn thha-anr-btn-danger thha-anr-icon-clear">Clear Icon</button>';
			html += '</div>';
			html += '<input class="thha-anr-input thha-anr-cell-label" type="text" value="' + escapeHtml(cell.label || '') + '" placeholder="Label" />';
			html += '</div>';
			html += '<button type="button" class="thha-anr-btn thha-anr-btn-danger thha-anr-remove-cell">Remove</button>';
			html += '</div>';
			return html;
		},

		getIndexes: function (eventTarget) {
			var $item = $(eventTarget).closest('[data-category-index]');
			return {
				categoryIndex: parseInt($item.attr('data-category-index'), 10),
				rowIndex: parseInt($item.attr('data-row-index'), 10),
				cellIndex: parseInt($item.attr('data-cell-index'), 10),
			};
		},

		onAddCategory: function () {
			this.matrix.push(normalizeCategory({}));
			this.refresh();
		},

		onRemoveCategory: function (event) {
			var index = this.getIndexes(event.currentTarget).categoryIndex;
			if (Number.isInteger(index) && this.matrix[index]) {
				this.matrix.splice(index, 1);
				this.refresh();
			}
		},

		onCategoryTitleChange: function (event) {
			var index = this.getIndexes(event.currentTarget).categoryIndex;
			if (Number.isInteger(index) && this.matrix[index]) {
				this.matrix[index].title = $(event.currentTarget).val();
				this.syncValue();
			}
		},

		onAddRow: function (event) {
			var index = this.getIndexes(event.currentTarget).categoryIndex;
			if (Number.isInteger(index) && this.matrix[index]) {
				this.matrix[index].rows.push(normalizeRow({}));
				this.refresh();
			}
		},

		onRemoveRow: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex]
			) {
				this.matrix[indexes.categoryIndex].rows.splice(indexes.rowIndex, 1);
				this.refresh();
			}
		},

		onRowNameChange: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].name = $(event.currentTarget).val();
				this.syncValue();
			}
		},

		onAddCell: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.push(defaultCell());
				this.refresh();
			}
		},

		onRemoveCell: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				Number.isInteger(indexes.cellIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells[indexes.cellIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.splice(indexes.cellIndex, 1);
				if (!this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.length) {
					this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.push(defaultCell());
				}
				this.refresh();
			}
		},

		onCellLabelChange: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			var cell = this.getCurrentCell(indexes.categoryIndex, indexes.rowIndex, indexes.cellIndex);
			if (cell) {
				cell.label = $(event.currentTarget).val();
				this.syncValue();
			}
		},

		onOpenIconPicker: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			var cell = this.getCurrentCell(indexes.categoryIndex, indexes.rowIndex, indexes.cellIndex);
			if (!cell || !elementor.iconManager || !elementor.iconManager.show) {
				return;
			}

			var controlView = this;
			var proxyView = {
				model: {
					get: function (key) {
						if ('skin' === key) {
							return 'media';
						}

						if ('default' === key) {
							return cell.icon || { value: '', library: '' };
						}

						return null;
					},
				},
				getControlValue: function () {
					return normalizeSelectedIcon( cell.icon );
				},
				setValue: function (value) {
					cell.icon = normalizeSelectedIcon( value );
				},
				applySavedValue: function () {
					controlView.syncValue();
					controlView.renderEditor();
				},
			};

			elementor.iconManager.show( { view: proxyView } );
			event.preventDefault();
			event.stopPropagation();
		},

		onClearIcon: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			var cell = this.getCurrentCell(indexes.categoryIndex, indexes.rowIndex, indexes.cellIndex);
			if (cell) {
				cell.icon = { value: '', library: '' };
				this.refresh();
			}
			event.preventDefault();
			event.stopPropagation();
		},
	});

	elementor.addControlView('advance_nasted_repeter_control', AdvanceNastedRepeterControl);
})(jQuery);
